import { Link as RouterLink, useLocation } from "react-router-dom";

import {
  Box,
  Divider,
  Link,
  Breadcrumbs as MUIBreadcrumbs,
  Typography,
} from "@mui/material";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';


const linkStyles = {
  textDecoration: 'none',
  color: "inherit",
  "&:hover": {
    textDecoration: "underline"
  }
}


const Breadcrumbs: React.FC = () => {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);

  return (
    <Box sx={{ height: "50px" }}>
      <MUIBreadcrumbs
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="breadcrumb"
        sx={{ height: "100%", display: "flex", p: 1.5 }}
      >
        <Link component={RouterLink} to="/" sx={linkStyles}>
          Home
        </Link>
        {pathnames.map((value, index) => {
          const last = index === pathnames.length - 1;
          const to = `/${pathnames.slice(0, index + 1).join("/")}`;

          return last ? (
            <Typography color="inherit" key={to}>
              {value.charAt(0).toUpperCase() + value.slice(1)}
            </Typography>
          ) : (
            <Link component={RouterLink} to={to} key={to} sx={linkStyles}>
              {value.charAt(0).toUpperCase() + value.slice(1)}
            </Link>
          );
        })}
      </MUIBreadcrumbs>
      <Divider />
    </Box>
  );
};

export default Breadcrumbs;
